document.addEventListener("DOMContentLoaded", () => {
  const forms = document.querySelectorAll("[id^='shipping-services-form-']")
  forms.forEach((form) => {
    const serviceSel = form.querySelector('select[name="contact[service]"]')
    const ifs = form.querySelectorAll("[data-ifs]")
    const scp = form.querySelectorAll("[data-scp]")
    const body = form.querySelector('[name="contact[body]"]')
    const toggle = () => {
      const isSC = serviceSel.value.indexOf("student-care") !== -1
      ifs.forEach((el) => (el.hidden = isSC))
      scp.forEach((el) => (el.hidden = !isSC))
    }
    serviceSel.addEventListener("change", toggle)
    toggle()
    
    // Clear error border when user starts typing
    const allInputs = form.querySelectorAll('input, textarea')
    allInputs.forEach(input => {
      input.addEventListener('input', () => {
        if (input.style.borderColor === 'rgb(255, 68, 68)' || input.style.borderColor === '#ff4444') {
          input.style.borderColor = ''
        }
      })
    })
    
    form.addEventListener("submit", (e) => {
      // Check if this is a bypass validation submit
      const bypassButton = e.submitter && e.submitter.getAttribute('data-bypass-validation')
      if (bypassButton) {
        // Allow form to submit normally
        return true
      }
      
      // ALWAYS prevent default first
      e.preventDefault()
      e.stopPropagation()
      
      // Get required fields
      const nameField = form.querySelector('[name="contact[name]"]')
      const emailField = form.querySelector('[name="contact[email]"]')
      const phoneField = form.querySelector('[name="contact[phone]"]')
      const messageField = form.querySelector('[name="contact[body]"]')
      const isSC = serviceSel.value.indexOf("student-care") !== -1
      const destField = isSC 
        ? form.querySelector('[name="contact[destination_student_care]"]')
        : form.querySelector('[name="contact[destination_india_shopping]"]')
      
      // Validate required fields
      const errors = []
      
      if (!nameField.value.trim()) {
        errors.push("Name is required")
        nameField.style.borderColor = "#ff4444"
      } else {
        nameField.style.borderColor = ""
      }
      
      if (!emailField.value.trim()) {
        errors.push("Email is required")
        emailField.style.borderColor = "#ff4444"
      } else {
        emailField.style.borderColor = ""
      }
      
      if (!phoneField.value.trim()) {
        errors.push("Phone number is required")
        phoneField.style.borderColor = "#ff4444"
      } else {
        phoneField.style.borderColor = ""
      }
      
      if (!destField.value.trim()) {
        errors.push("Destination country & postcode is required")
        destField.style.borderColor = "#ff4444"
      } else {
        destField.style.borderColor = ""
      }
      
      if (!messageField.value.trim()) {
        errors.push("Message is required")
        messageField.style.borderColor = "#ff4444"
      } else {
        messageField.style.borderColor = ""
      }
      
      // If there are errors, show alert and STOP
      if (errors.length > 0) {
        alert("Please fill all required fields:\n\n• " + errors.join("\n• "))
        // Scroll to first error field
        const firstErrorField = [nameField, emailField, phoneField, destField, messageField].find(f => !f.value.trim())
        if (firstErrorField) {
          firstErrorField.focus()
          firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        return false
      }
      
      // If validation passes, compile data and submit
      const data = {}
      ;["orders", "pickup", "contents", "destination_india_shopping", "destination_student_care"].forEach((name) => {
        const el = form.querySelector(`[name="contact[${name}]"]`)
        if (el && el.value) data[name] = el.value
      })
      const existing = messageField.value ? messageField.value.trim() + "\n\n" : ""
      messageField.value =
        existing +
        "— Shipping Services Booking (compiled) —\n" +
        `Service: ${serviceSel.options[serviceSel.selectedIndex].text}\n` +
        (data.orders ? `Orders: ${data.orders}\n` : "") +
        (data.pickup ? `Pickup: ${data.pickup}\n` : "") +
        (data.contents ? `Contents: ${data.contents}\n` : "") +
        (data.destination_india_shopping ? `Destination: ${data.destination_india_shopping}\n` : "") +
        (data.destination_student_care ? `Destination: ${data.destination_student_care}\n` : "")
      
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ event: "shipping_services_booking_submit", service: serviceSel.value })
      
      // Create a hidden submit button and click it to properly submit the form
      const submitBtn = document.createElement('button')
      submitBtn.type = 'submit'
      submitBtn.style.display = 'none'
      submitBtn.setAttribute('data-bypass-validation', 'true')
      form.appendChild(submitBtn)
      submitBtn.click()
      form.removeChild(submitBtn)
    })
  })
  document.querySelectorAll(".accordion details").forEach((d) => {
    d.addEventListener("toggle", () => {
      if (d.open) {
        document.querySelectorAll(".accordion details[open]").forEach((x) => {
          if (x !== d) x.open = false
        })
      }
    })
  })
})
